<script setup>
import { useUiStore } from '@/stores/UiStore'
import { VIEW_LOAD } from '@/constants/dispatch'

/**
 * The component's inherited properties.
 */
const props = defineProps({
    /**
     * The load's ID.
     *
     * @type {Number}
     */
    value: {
        type: Number,
        required: true,
    },
})

/**
 * Store instances.
 */
const uiStore = useUiStore()

/**
 * The onPreviewClick method.
 *
 * @return {void}
 */
const onPreviewClick = () => {
    uiStore.openAction(VIEW_LOAD, { id: props.value })
}
</script>

<template>
    <div
        class="ag-dispatch-main-cell flex items-center justify-between w-36"
        data-test="dispatch-main-cell"
    >
        <a
            :href="`/index.cfm?module=dispatch&template=dspLoad&intLoadId=${value}`"
            class="font-semibold hover:underline"
            data-test="load-id-cell"
        >
            {{ value }}
        </a>
        <button
            class="ag-quick-view-btn absolute right-1 border border-edge p-[0.2rem] rounded-sm text-xs font-light bg-white"
            data-test="dispatch-main-cell-preview-btn"
            @click="onPreviewClick"
        >
            <span class="text-gray-500"> Quick View </span>
        </button>
    </div>
</template>
